import styled from 'styled-components';
import { red } from 'core/styles';

const Title = styled.h1`
  font-size: 2rem;
  color: ${red};
  text-align: center; // web specific
`;
export default Title;
